module.exports = __webpack_public_path__ + "img/nav-logo.5dbc07f.png";